import React from 'react';
import moment from 'moment';
import Pagination from '../common/Pagination';

const ContactTable = ({
  contactUsList,
  currentPage,
  itemsPerPage,
  onPageChange,
  handleItemClick
}) => {
  const getCurrentItems = (items) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items?.slice(indexOfFirstItem, indexOfLastItem);
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title fw-bold mb-3">Contact Messages</h5>
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Date</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {getCurrentItems(contactUsList).map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{moment(item.createdAt).format("DD-MM-YYYY")}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() => handleItemClick(item, "contact")}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalItems={contactUsList.length}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default ContactTable; 